import api from "../../../helpers/api";

export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";
export const SOCIAL_LOGIN = "SOCIAL_LOGIN";

export const loginUser = (user, navigate) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER }); // Set loading state
    
    // API CALL HAPPENS HERE
    const response = await api.post("/api/auth/login", user);
    const { data } = response;
    
    // Store user data
    localStorage.setItem("authUser", JSON.stringify(data));
    
    dispatch(loginSuccess(data.user));
    navigate("/dashboard");
  } catch (error) {
    dispatch(apiError(error.response?.data?.message || "Login failed"));
  }
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,  // This will now store the user data in the Redux store
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};